import { ActivityState } from '@/lib/enums';
import getActivityStateCondition from './getActivityStateCondition';

/**
 * Creates a copy of the immutable conditions to be extended.
 *
 * @param {Object} conditions
 *
 * @return {Object}
 */
const defaultEntities = (conditions) => {
  return {
    activities: [...(conditions?.activities ?? [])],
    groups: [...(conditions?.groups ?? [])],
    people: [...(conditions?.people ?? [])],
    roles: [...(conditions?.roles ?? [])],
    skills: [...(conditions?.skills ?? [])],
  };
};

/**
 * Extends the stored filter conditions with permanent conditions.
 *
 * @param {string} activityState
 * @param {Object} filterConditions
 *
 * @return {Object}
 */
export default function extendFilterConditions(
  activityState,
  filterConditions,
  resetFilters
) {
  if (activityState === ActivityState.ALL) {
    return {
      conditions: resetFilters ? defaultEntities() : filterConditions,
      empty: true,
    };
  }

  const conditions = defaultEntities(filterConditions);
  const empty = false;

  const activityCondition = getActivityStateCondition(activityState);
  conditions.activities.push(activityCondition);

  return { conditions, empty };
}
